import { useMemo } from 'react'

import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { getCrossPostProvidersForBrandPlanTactics } from 'screens/Calendar/FullScreenPreview/utils'
import { BrandPlanTactic } from 'types'

export const useCrossPostAccountsToConnectCount = (tactics: BrandPlanTactic[] | undefined) => {
  const { data: integrationsData } = useExternalIntegrations()

  const crossPostGroup = useMemo(() => getCrossPostProvidersForBrandPlanTactics(tactics), [tactics])

  const { accountsToConnectCount, unconnectedProviders } = useMemo(() => {
    const connectedProviders = new Set(integrationsData?.external_integrations?.map((i) => i.provider) ?? [])
    const unconnected = crossPostGroup.filter((p) => !connectedProviders.has(p))

    return {
      accountsToConnectCount: unconnected.length,
      unconnectedProviders: unconnected,
    }
  }, [crossPostGroup, integrationsData])

  return {
    accountsToConnectCount,
    crossPostGroup,
    unconnectedProviders,
  }
}
